import Text from 'mrf/layout/Text';
import React from 'react';
import { StyledStep, StyledStepIcon, StyledStepLabel, StyledStepSpacer } from 'styles/components/Stepper.styles';

export const Step = ({ icon: Icon, label, active=false, visited=false, labelSize }) => {
    return (
        <StyledStep active={active} visited={visited}>
            <StyledStepIcon>
                <Icon />
            </StyledStepIcon>
            <StyledStepLabel>
            <Text
                    style={labelSize ? { fontSize: labelSize } : undefined}
                >
                    {label}
                </Text>
            </StyledStepLabel>
        </StyledStep>
    );
}

export default function Stepper({ step = 1, labelSize, children }) {
    const arrayChildren = React.Children.toArray(children);
    return (
        <div className='flex w-full p-4 mx-4 mb-4'>
            <div className='flex items-center w-full'>
                {arrayChildren?.length && arrayChildren
                    ?.map((child, idx) => React.cloneElement(child, { active: step === idx + 1 , visited: step >= idx + 1, labelSize }))
                    ?.reduce((prev, curr, idx) => [prev, <StyledStepSpacer key={idx} active={step >= idx + 1} />, curr])
                }
            </div>
        </div>
    );
}
